import { RelationalActionParameter } from ".";

export interface IEmptyValidationSuppressible {
  parentAlertInformations: RelationalActionParameter[];
  isSuppressionActive: boolean;
}

export function instanceOfIEmptyValidationSuppressible(instance: any): instance is IEmptyValidationSuppressible {
  if (!instance) { return false; }
  return (instance.parentAlertInformations !== undefined) && (instance.isSuppressionActive !== undefined);
}
